import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    booking: { Success: false, Data: [] },
    quickBooking: { Success: false, Data: [] },
    status: 'idle',
    quickStatus: 'idle',
    bookingSource: '',
    addStatus: 'idle',
    addQuickStatus: 'idle',
    error: null,
    dateRange: [],
};

export const resetAddBookingStatus = createAsyncThunk(
    'school/resetAddBookingStatus',
    async () => {
        const myPromise = new Promise((resolve, reject) => {
            console.log('Called the reset booking');
            resolve(true);
        });
        myPromise();
    }
);

export const fetchSchoolBooking = createAsyncThunk(
    'school/fetchSchoolBookings',
    async data => {
        const response = await axios.get('/getSchoolBookings', {
            params: {
                'date1': data.date1,
                'date2': data.date2,
                'status1': data.status1,
                'status2': data.status2,
                'status3': data.status3,
            },
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: `/getSchoolBookings`,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${data.token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
);

export const fetchTeacherBooking = createAsyncThunk(
    'teacher/fetchTeacherBookings',
    async data => {
        console.log('booking data', data);
        const response = await axios.get('/getTeacherBookings', {
            params: {
                'date1': data.date1,
                'date2': data.date2,
                'status1': data.status1,
                'status2': data.status2,
            },
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: `/getTeacherBookings`,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${data.token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
);

// need to obtain token silently before the API call and remove from availability page
export const addBooking = createAsyncThunk('teacher/addBooking', async data => {
    const headers = {
        authorization: 'Bearer ' + data.token,
        'Content-Type': 'application/json',
    };
    const response = await axios.post('/addBooking', data.request, {
        baseURL: process.env.REACT_APP_API_GATEWAY,
        url: '/addBooking',
        timeout: 30000,
        headers: headers,
    });
    return await response;
});

export const addQuickBooking = createAsyncThunk(
    'teacher/addQuickBooking',
    async data => {
        const headers = {
            authorization: 'Bearer ' + data.token,
            'Content-Type': 'application/json',
        };
        const response = await axios.post('/addQuickBooking', data.request, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: '/addQuickBooking',
            timeout: 30000,
            headers: headers,
        });
        return await response;
    }
);

export const fetchQuickBooking = createAsyncThunk(
    'teacher/fetchQuickBooking',
    async data => {
        const response = await axios.get('/getTeacherQuickBooking', {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: '/getTeacherQuickBooking',
            timeout: 30000,
            headers: {
                authorization: `Bearer ${data.token}`,
                'Content-Type': 'application/json',
            },
        });
        return response;
    }
);

export const cancelBooking = createAsyncThunk(
    'teacher/cancelBooking',
    async data => {
        const headers = {
            authorization: 'Bearer ' + data.token,
            'Content-Type': 'application/json',
        };
        const response = await axios.delete(
            `${process.env.REACT_APP_API_GATEWAY}/cancelBooking`,
            {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: '/cancelBooking',
                timeout: 30000,
                headers: headers,
                data: {
                    source: {
                        pk1: data.request.pk1,
                        sk1: data.request.sk1,
                    },
                },
            }
        );
        return await response;
    }
);

const bookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        bookingAdded(state, action) {
            const {
                grade,
                teacherName,
                teacherProfile,
                skills,
                otherSkills,
                bio,
                geoJSON,
                startDate,
                endDate,
                status,
                repeat,
                pk1,
                sk1,
            } = action.payload;
            const currentBooking = state.booking;
            if (currentBooking) {
                currentBooking.otherSkills = otherSkills;
                currentBooking.teacherName = teacherName;
                currentBooking.teacherProfile = teacherProfile;
                currentBooking.skills = skills;
                currentBooking.bio = bio;
                currentBooking.grade = grade;
                currentBooking.geoJSON = geoJSON;
                currentBooking.startDate = startDate;
                currentBooking.endDate = endDate;
                currentBooking.repeat = repeat;
                currentBooking.status = status;
                currentBooking.sk1 = sk1;
                currentBooking.pk1 = pk1;
            }
        },
        updateStatus(state, action) {
            console.log('update booking status slice ', action);
            var interimState = state.booking.Data;
            const indexNumber = interimState.findIndex(
                x => x.uniqueId === action.payload.id
            );
            if (interimState[indexNumber] !== undefined) {
                interimState[indexNumber].status = action.payload.status;

                state.booking.Data = interimState;
            } else {
                interimState = state.quickBooking.Data;
                const indexQuickNumber = interimState.findIndex(
                    x => x.uniqueId === action.payload.id
                );
                if (indexQuickNumber !== -1) {
                    interimState[indexQuickNumber].status =
                        action.payload.status;
                    state.quickBooking.Data = interimState;
                }
            }
        },
        quickBookingConfirmed(state, action) {
            console.log('update booking status slice ', action);

            let interimState = state;

            if (action.payload.Message.Success === true) {
                console.log(
                    'Bookings',
                    JSON.stringify(interimState.booking.Data)
                );
                console.log(
                    'Quick Booking Item',
                    JSON.stringify(interimState.quickBooking.Data)
                );
                interimState.booking.Data.push(
                    action.payload.Message.Data.createdBooking
                );

                console.log(
                    'Updated Bookings',
                    JSON.stringify(interimState.booking.Data)
                );

                const qbState = interimState.quickBooking.Data.map(qb => {
                    if (
                        qb.uniqueId ===
                        action.payload.Message.Data.quickBookUniqueId
                    ) {
                        return {
                            ...qb,
                            status: action.payload.Message.Data
                                .quickBookingStatus,
                            bookedBy: {
                                uniqueId:
                                    action.payload.Message.Data
                                        .quickBookingUserUniqueId,
                            },
                        };
                    } else {
                        return qb;
                    }
                });
                interimState.quickBooking.Data = qbState;

                state = interimState;
            }
        },
        schoolPreBookingUpload(state, action) {
            console.log('update booking school upload ', action);
            var interimState = state.booking.Data;
            const indexNumber = interimState.findIndex(
                x => x.uniqueId === action.payload.id
            );
            if (
                typeof interimState[indexNumber].uploadedDocuments !==
                'undefined'
            ) {
                interimState[indexNumber].uploadedDocuments.push({
                    date: Date.now(),
                    text: action.payload.schoolUploadText,
                    userName: action.payload.user,
                    thisUser: true,
                    document: action.payload.schoolUploadDocument,
                });
            } else {
                interimState[indexNumber].uploadedDocuments = [
                    {
                        date: Date.now(),
                        text: action.payload.schoolUploadText,
                        userName: action.payload.user,
                        thisUser: true,
                        document: action.payload.schoolUploadDocument,
                    },
                ];
            }

            state.booking.Data = interimState;
        },
        teacherFeedback(state, action) {
            console.log('update booking w teacher feedback', action);
            var interimState = state.booking.Data;
            const indexNumber = interimState.findIndex(
                x => x.uniqueId === action.payload.id
            );

            interimState[indexNumber].teacherFeedback = action.payload.feedback;
            interimState[indexNumber].status = 'Completed';

            state.booking.Data = interimState;
        },
        ratingComplete(state, action) {
            console.log('update booking w teacher feedback', action);
            var interimState = state.booking.Data;
            const indexNumber = interimState.findIndex(
                x => x.uniqueId === action.payload.id
            );
            if (action.payload.status !== '') {
                interimState[indexNumber].teacherRating =
                    action.payload.teacherRating;
                interimState[indexNumber].teacherRatingComments =
                    action.payload.teacherRatingComments;
                interimState[indexNumber].status = action.payload.status;

                state.booking.Data = interimState;
            } else {
                interimState[indexNumber].teacherRating =
                    action.payload.teacherRating;
                interimState[indexNumber].teacherRatingComments =
                    action.payload.status;
                interimState[indexNumber].status = 'Processed';

                state.booking.Data = interimState;
            }
        },
    },
    extraReducers: {
        [fetchSchoolBooking.pending]: (state, action) => {
            state.status = 'loading';
        },
        [fetchSchoolBooking.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.bookingSource = action.meta.arg.location;
            if (
                typeof action.meta.arg.date1 !== 'undefined' &&
                typeof action.meta.arg.date2 !== 'undefined'
            ) {
                state.dateRange = [
                    action.meta.arg.date1,
                    action.meta.arg.date2,
                ];
            }
            // Add any fetched posts to the array
            console.log(
                'Need to format date into this ' + action.meta.arg.location
            );

            state.booking = action.payload.booking.Message;
        },
        [fetchSchoolBooking.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        [fetchTeacherBooking.pending]: (state, action) => {
            state.status = 'loading';
        },
        [fetchTeacherBooking.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.bookingSource = action.meta.arg.location;
            if (
                typeof action.meta.arg.date1 !== 'undefined' &&
                typeof action.meta.arg.date2 !== 'undefined'
            ) {
                state.dateRange = [
                    action.meta.arg.date1,
                    action.meta.arg.date2,
                ];
            }
            // Add any fetched posts to the array
            console.log(
                'Need to format date into this ' +
                    JSON.stringify(action.meta.arg.location)
            );

            state.booking = action.payload.booking.Message;
        },
        [fetchTeacherBooking.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        [fetchQuickBooking.pending]: (state, action) => {
            state.quickStatus = 'loading';
        },
        [fetchQuickBooking.fulfilled]: (state, action) => {
            if (action.payload.data.Message.Success === true) {
                state.quickStatus = 'succeeded';
                state.quickBooking = action.payload.data.Message;
            } else {
                state.quickStatus = 'failed';
                state.error = action.payload;
            }
        },
        [fetchQuickBooking.rejected]: (state, action) => {
            state.quickStatus = 'failed';
            state.error = action.payload;
        },
        [addBooking.pending]: (state, action) => {
            state.addStatus = 'loading';
        },
        [addBooking.fulfilled]: (state, action) => {
            var interimState = action.payload.data;
            if (interimState.Message.Success === true) {
                state.addStatus = 'succeeded';
                console.log('Booking Item' + JSON.stringify(interimState));
                state.booking.Data.push(interimState.Message.Data);
            }
        },
        [addQuickBooking.pending]: (state, action) => {
            state.addQuickStatus = 'loading';
        },
        [addQuickBooking.fulfilled]: (state, action) => {
            var interimState = action.payload.data;
            if (interimState.Message.Success === true) {
                state.addQuickStatus = 'succeeded';
                console.log('Booking Item' + JSON.stringify(interimState));
                state.booking.Data.push(interimState.Message.Data);
            }
        },
        [addQuickBooking.rejected]: (state, action) => {
            state.quickBooking.Success = false;
        },
        [cancelBooking.pending]: (state, action) => {
            state.addStatus = 'loading';
        },
        [cancelBooking.fulfilled]: (state, action) => {
            var interimState = action.payload.data;
            console.log('Cancelling Booking');
            console.log('interimState.Message', interimState.Message);

            if (interimState.Message.Success) {
                const editedArray = state.booking.Data.map(element => {
                    if (
                        element.uniqueId ===
                        interimState.Message.Data.uniqueId.S
                    ) {
                        element.status = 'Cancelled';
                    }
                    return element;
                });

                state.booking.Data = editedArray;

                state.addStatus = 'succeeded';
            }
        },
        [addBooking.rejected]: (state, action) => {
            state.addStatus = 'failed';
            // Add any fetched posts to the array
            console.log(
                'Need to format date into this ' + JSON.stringify(action)
            );
        },
        [resetAddBookingStatus.pending]: (state, action) => {
            console.log('does it every make it to the action of the reset? 2');
            state.addStatus = 'idle';
        },
        [resetAddBookingStatus.fulfilled]: (state, action) => {
            console.log('does it every make it to the action of the reset?');
            state.addStatus = 'idle';
        },
    },
});

export const {
    quickBookingConfirmed,
    bookingAdded,
    updateStatus,
    schoolPreBookingUpload,
    teacherFeedback,
    ratingComplete,
} = bookingSlice.actions;

export default bookingSlice.reducer;

export const getBooking = state => state.booking;
